module.exports = __webpack_public_path__ + "img/w3_bookmark_solid_grey.aae52900.png";